import { Context, FC, createContext, useCallback, useMemo } from 'react';
import { DynamicHeaderGroup, DynamicHeaderContextInterface } from 'swo-ciam-common-react';

export const DynamicHeaderContext: Context<DynamicHeaderContextInterface | null> =
  createContext(null);
export const DynamicHeaderProvider: FC = ({ children }) => {
  const handlers: Map<DynamicHeaderGroup, Function> = useMemo(() => new Map(), []);

  const registerReceiverHandler = useCallback(
    (name: DynamicHeaderGroup, callback: Function) => {
      handlers.set(name, callback);
    },
    [handlers]
  );
  const sendReceiverData = useCallback(
    (name: DynamicHeaderGroup, location: string, data) =>
      handlers.has(name) ? handlers.get(name)(location, data) : undefined,
    [handlers]
  );
  return (
    <DynamicHeaderContext.Provider
      value={{
        registerReceiverHandler,
        sendReceiverData,
      }}
    >
      {children}
    </DynamicHeaderContext.Provider>
  );
};
